import { Inspector } from '@sequencehq/core-components'
import { QuoteInformationInspectorItem } from './items/QuoteInformationInspectorItem'
import {
  HubspotInspectorItem,
  LinkHubSpotCustomerWidget,
  LinkHubSpotDealWidget,
  LinkSalesforceAccountWidget,
  LinkSalesforceOpportunityWidget,
  SalesforceInspectorItem
} from 'Integrations/index'
import { useQuoteEditorInspector } from './useQuoteEditorInspector'
import { AttachmentsInspectorItem } from './items/AttachmentsInspector'
import { QuoteSettingsInspectorItem } from './items/QuoteSettingsInspectorItem'
import { AttioQuoteInspectorItem } from 'Integrations/integrationsConfig/attio/InspectorItem/AttioInspectorItem'
import { QuoteAnalyticsInspectorItem } from './items/QuoteAnalyticsInspector'
import { ActivityLogsInspectorItem } from 'ActivityLogs/ActivityLogsInspectorItem/ActivityLogsInspectorItem'
import { WorkflowsInspectorItem } from 'Automations/index'

export const QuoteEditorInspector: React.FC = () => {
  const hook = useQuoteEditorInspector()

  return (
    <Inspector showContentOnMount>
      <Inspector.ItemGroup>
        <QuoteInformationInspectorItem />
        {hook.externalIntegrations.visible && (
          <>
            <SalesforceInspectorItem>
              <LinkSalesforceAccountWidget
                {...hook.externalIntegrations.salesforce.customerLinking}
              />
              <LinkSalesforceOpportunityWidget
                sequenceEntityLabel="quote"
                {...hook.externalIntegrations.salesforce.opportunityLinking}
              />
            </SalesforceInspectorItem>
            <HubspotInspectorItem>
              <LinkHubSpotCustomerWidget
                {...hook.externalIntegrations.hubspot.customerLinking}
              />
              <LinkHubSpotDealWidget
                sequenceEntityLabel="quote"
                {...hook.externalIntegrations.hubspot.dealLinking}
              />
            </HubspotInspectorItem>
            <AttioQuoteInspectorItem quoteId={hook.quoteId} />
          </>
        )}
        <AttachmentsInspectorItem />
        <QuoteAnalyticsInspectorItem />
        <QuoteSettingsInspectorItem />
        <ActivityLogsInspectorItem
          entityId={hook.quoteId}
          entityType="QUOTE"
          enabled
        />
        <WorkflowsInspectorItem entityId={hook.quoteId} entityType="QUOTE" />
      </Inspector.ItemGroup>
    </Inspector>
  )
}
